module.exports = __webpack_public_path__ + "img/thumb_image9.f37bdca5.jpg";